import React from 'react'

const provincesContext = React.createContext({});

export { provincesContext }
